import { AppCatalogWmsProductService } from "../resource";
import { wmsPickerParams, wmsPickerRows, wmsPickerTotal } from "../utils/wmsImportModal";

const AppCatalogWmsProductModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        }
    },
    actions: {
        async fetchPgList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogWmsProductService.listPg(params);
                const body = res.data || {};
                commit("SET_LIST", body.data || []);
                commit("SET_TOTAL", body.total || 0);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
                throw err; // let the page's loadList() catch surface a toast
            } finally {
                commit("SET_LOADING", false);
            }
        },
        // Raw pass-through, kept for callers that send the old `{q, limit}` form.
        // Returns the axios response as before — do not "improve" this signature,
        // it is the compatibility seam.
        search(_, params) {
            return AppCatalogWmsProductService.search(params);
        },
        // The import modal's paged list. Resolves to {rows, total, page, pageSize}
        // so the dialog never touches res.data.data, and tolerates a body without
        // `total` (see wmsPickerTotal).
        async listBoProducts(_, payload) {
            const params = wmsPickerParams(payload);
            const res = await AppCatalogWmsProductService.list(params);
            return {
                rows: wmsPickerRows(res),
                total: wmsPickerTotal(res),
                page: params.page,
                pageSize: params.page_size
            };
        },
        importProducts(_, payload) {
            return AppCatalogWmsProductService.importProducts(payload);
        },
        setStock(_, { wmsId, payload }) {
            return AppCatalogWmsProductService.setStock(wmsId, payload);
        },
        syncFromBackoffice(_) {
            return AppCatalogWmsProductService.sync();
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error
    }
};

export default AppCatalogWmsProductModule;
